import { asError, getLogger } from '@trimble/logging';

const parseStoredSelections = (
  raw: string | null,
  multipleSelection: boolean
): string[] => {
  if (!raw) {
    return [];
  }

  if (!multipleSelection) {
    return [raw];
  }

  try {
    const parsed: unknown = JSON.parse(raw);
    if (Array.isArray(parsed)) {
      return parsed.filter((id): id is string => typeof id === 'string');
    }
  } catch {
    // Legacy single-id value stored before multiple-selection support.
  }

  return [raw];
};

export const readStoredSelections = (
  storageKey: string,
  multipleSelection: boolean
): string[] => {
  try {
    return parseStoredSelections(
      sessionStorage.getItem(storageKey),
      multipleSelection
    );
  } catch (error) {
    getLogger().warn(
      'Failed to read split dropdown stored selection',
      { storageKey },
      asError(error)
    );
    return [];
  }
};

export const writeStoredSelections = (
  storageKey: string,
  multipleSelection: boolean,
  itemIds: string[]
): void => {
  try {
    if (multipleSelection) {
      sessionStorage.setItem(storageKey, JSON.stringify(itemIds));
      return;
    }

    const lastItemId = itemIds.at(-1);
    if (lastItemId) {
      sessionStorage.setItem(storageKey, lastItemId);
      return;
    }

    sessionStorage.removeItem(storageKey);
  } catch (error) {
    getLogger().warn(
      'Failed to store split dropdown selection',
      { storageKey, itemIds },
      asError(error)
    );
  }
};
